import {Component, OnInit} from '@angular/core';
import {HotkeysService} from '../../modules/hotkeys/hotkeys.service';
import {Hotkeys} from '../../modules/hotkeys/hotkeys.enum';
import {Observable} from 'rxjs';
import {map, startWith, tap} from 'rxjs/operators';
import {Store} from '@ngxs/store';

@Component({
  selector: 'gg-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss']
})
export class ConsoleComponent implements OnInit {
  show$: Observable<boolean>;
  stats$: Observable<any>;
  log$: Observable<any>;

  private avgSpeedI: number = 0;
  private avgSpeedValue: number = 0;

  private show = false;

  constructor(private store: Store, private hotkeysService: HotkeysService) {
    this.log$ = this.store.select(state => state.player.log).pipe(
      map(arr => arr.join('\n')),
      map(str => str.replace(/([^>])\n/g, '$1<br/>'))
    );
  }

  ngOnInit() {
    this.show$ = this.hotkeysService.on(Hotkeys.console).pipe(
      startWith(this.show),
      map(() => this.show),
      tap(() => this.show = !this.show),
    );

    this.stats$ = this.store.select(state => state.player.stats)
      .pipe(
        map(stats => ({
          ...stats,
          avgspeed: this.avgSpeed(stats.speed)
        }))
      );

  }

  getQualityFromLevel(currentLevel: any) {
    return {3: 'source', 2: '720', 1: '480', 0: '240'}[currentLevel] || currentLevel;
  }

  private avgSpeed(speed) {
    if (!speed) {
      return 0;
    }
    if (this.avgSpeedI > 100) {
      this.avgSpeedI = 0;
      this.avgSpeedValue = 0;
    }

    this.avgSpeedValue = ((this.avgSpeedValue * this.avgSpeedI) + speed) / (this.avgSpeedI + 1);
    this.avgSpeedI++;

    return Math.round(this.avgSpeedValue);
  }
}
